// @flow

/**
 * Module dependencies.
 */

import { Col, Row } from 'client/components/core/grid';
import { Separator } from 'client/components/separator';
import { breakpoints, colors, media, units } from 'client/styles';
import Icon from 'client/components/core/icon';
import Layout from 'client/components/core/layout';
import MediaQuery from 'react-responsive';
import Raw from 'react-raw-html';
import React from 'react';
import Text from 'client/components/core/type';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  icon: string,
  text: string,
  textColor?: string,
  title: string,
  titleColor?: string
};

/**
 * `ColFlexCenter` styled component.
 */

const ColFlexCenter = styled(Col)`
  ${media.min.md`
    display: flex;
    flex-direction: column;
    justify-content: center;
  `}
`;

/**
 * Styles.
 */

const styles = {
  icon: `
    svg {
      max-height: 250px;
      margin-left: -15%;
    }

    ${media.min.sm`
      svg {
        margin-right: -15%;
        transform: translateX(-5%);
      }
    `}

    ${media.min.md`
      svg {
        max-height: 364px;
        margin-left: -20%;
        margin-right: 0;
        width: 135%;
      }
    `}

    ${media.min.lg`
      svg {
        margin-left: 0;
        width: 100%;
      }
    `}
  `,
  separator: (color: string = colors.brandPrimary): string => `
    background-color: ${color};

    ${media.max.md`
      display: none;
    `};
  `
};

/**
 * `Operation` component.
 */

function Operation(props: Props): React$Element<*> {
  const {
    icon,
    text,
    textColor,
    title,
    titleColor
  } = props;

  return (
    <Row>
      <Layout displaySm={'flex'}>
        <ColFlexCenter
          lg={4}
          lgOffset={1}
          md={3}
          mdOffset={2}
          xs={4}
          xsHidden
          xsOffset={1}
        >
          <Icon
            icon={icon}
            size={'100%'}
            styles={styles.icon}
          />
        </ColFlexCenter>

        <ColFlexCenter
          sm={5}
          smOffset={1}
          xs={10}
          xsOffset={1}
        >
          <Layout marginBottomMd={units(6)}>
            <Text.H2
              color={titleColor}
              weight={600}
            >
              {title}
            </Text.H2>
          </Layout>

          <Row>
            <Layout position={'relative'}>
              <MediaQuery minWidth={breakpoints.md}>
                <Separator.Horizontal
                  styles={styles.separator(titleColor)}
                  topRight
                />
              </MediaQuery>

              <Col
                md={10}
                mdOffset={2}
                xs={12}
              >
                <Layout
                  displaySm={'none'}
                  paddingBottom={units(2)}
                  paddingTop={units(3)}
                >
                  <Icon
                    icon={icon}
                    size={'100%'}
                    styles={styles.icon}
                  />
                </Layout>

                <Text.H4
                  color={textColor}
                  weight={300}
                >
                  <Raw.span>
                    {text}
                  </Raw.span>
                </Text.H4>
              </Col>
            </Layout>
          </Row>
        </ColFlexCenter>
      </Layout>
    </Row>
  );
}

/**
 * Export `Operation`.
 */

export default Operation;



// WEBPACK FOOTER //
// ../src/client/components/how-it-works/operation.js